import axios from 'axios';
import { adquireTokenSilent } from '../authorization/authorization';
import { addNotificationsMessage } from '../store/notifications/actions';
import { Notifications } from '../store/notifications/types';
import { signOut } from './location/locationService';
import { getSettings } from './settingsService';
import { getStore } from '../store/store';
import { Dispatch } from 'redux';

const settings = getSettings();

const POLICY_SCOPE = {
  PERMISSION: 'Permission',
  ACCESS: 'Access'
}

export const createNewAxiosInstance = () => {
  const newApi = axios.create({
    baseURL: settings.webApiUrl,
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  newApi.interceptors.request.use(
    async (config) => {
      const token = await adquireTokenSilent();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return {
        ...config,
        url:
          config.method?.toLowerCase() === 'get' ? `${config.url}` : config.url,
        //  url: config.method?.toLowerCase() === 'get' ? `${config.url}?r=${`${Math.random()}`.split('.')[1]}` : config.url,
        headers: {
          ...config.headers,
        },
      };
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  newApi.interceptors.response.use((config) => ({
    ...config,
    headers: {
      ...config.headers,
      'Cache-Control': 'no-cache, no-transform',
    },
  }));

  newApi.interceptors.response.use(
    (response) => response,
    (error) => {
    if (
        error.response &&
        (error.response.status === 401)
      ) {
        signOut();
      } else 
      if ( error.response && (error.response.status === 403)) {
        const permission = error.response.data["Scope"];
        const message = error.response.data["Message"];
        
        if(permission === POLICY_SCOPE.PERMISSION) {
          const dispatch = getStore()?.dispatch as Dispatch<any>;
          let notification: Notifications = {message:message};

          dispatch(addNotificationsMessage(notification));
        } else {
          signOut();
        }
      }
      return Promise.reject(error);
    }
  );

  return newApi;
};

export const createNewAxiosInstanceNoAuthorized = () => {
  return axios.create({
    baseURL: settings.webApiUrl,
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const apiClientNoAuthorized = createNewAxiosInstanceNoAuthorized();

export const apiClient = createNewAxiosInstance();
